module.exports = __webpack_public_path__ + "img/mona-lisa-display.05e7d5ef.png";